<template>
  <div :class="[display, justifyText, 'items-center']">
    <h1 class="font-semibold" :class="[fontSize, position]">
      <slot></slot>
    </h1>
    <slot name="right"></slot>
  </div>
</template>

<script>
export default {
  name: "Heading",
  computed: {
    fontSize() {
      switch (this.size) {
        case "extra":
          return "text-3xl lg:text-5xl";
        case "large":
          return "text-2xl  lg:text-3xl";
        case "small":
          return "text-lg";
        default:
          return "text-3xl";
      }
    },

    position() {
      return this.center ? "text-center" : "";
    },

    _size() {
      if (this.extraLarge) {
        return "text-3xl md:text-5xl";
      } else {
        return "text-3xl";
      }
    },

    justifyText() {
      return `justify-${this.justify}`;
    },

    display() {
      return "flex";
    }
  },
  props: {
    size: {
      type: String,
      default: "large"
    },
    center: {
      type: Boolean,
      default: false
    },
    extraLarge: {
      type: Boolean,
      default: false
    },
    justify: {
      type: String,
      default: "between"
    }
  }
};
</script>

<style scoped></style>
